import { render, staticRenderFns } from "./AnswerMatrix.vue?vue&type=template&id=09c1f55a&scoped=true"
import script from "./AnswerMatrix.vue?vue&type=script&lang=js"
export * from "./AnswerMatrix.vue?vue&type=script&lang=js"
import style0 from "./AnswerMatrix.vue?vue&type=style&index=0&id=09c1f55a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c1f55a",
  null
  
)

export default component.exports